import DeleteModal from "Components/Common/DeleteModal";
import TableContainer from "Components/Common/TableContainer";
import { formatarDataHora } from "helpers/fomatar-data.helper";
import { isEmpty } from "lodash";
import { socket } from "pages/socket/socket";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Alert, Card, CardHeader, Row } from "reactstrap";
import { createSelector } from "reselect";
import {
  finalizarAutoAtendimento,
  liberarAutoAtendimento,
  painelControleAutoAtendimento,
} from "slices/Empresa/thunk";

interface PainelControleListaAutoAtendimentoProps {
  setIsEdit: (edit: boolean) => void;
  registro: boolean;
  setRegistro: (modelo: any) => void;
}

const PainelControleListaAutoAtendimento: React.FC<
  PainelControleListaAutoAtendimentoProps
> = ({ setIsEdit, registro, setRegistro }) => {
  const [mensagem, setMensagem] = useState<any>(null);
  const [empresa, setEmpresa] = useState<any>(null);
  const [addModal, setAddModal] = useState<boolean>(false);
  const [entrou, setEntrou] = useState<boolean>(false);

  socket.on("empresas-auto-atendimento", (sockets: any) => {
    setMensagem(sockets);
  });

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.ControleAtendimento;
  const selectLayoutProperties = createSelector(selectLayoutState, (state) => ({
    controleAtendimentoList: state.controleAtendimentoAutoAtendimentoList,
    isControleAtendimentoSuccess: state.isControleAtendimentoSuccess,
  }));
  const { controleAtendimentoList, isControleAtendimentoSuccess } = useSelector(
    selectLayoutProperties
  );
  const [
    controleAtendimentoAutoAtendimentoList,
    setControleAtendimentoAutoAtendimentoList,
  ] = useState<any>([]);
  const [itensPorPagina, setItensPorPagina] = useState<number>(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [editarModal, setEditarModal] = useState<boolean>(false);

  useEffect(() => {
    setControleAtendimentoAutoAtendimentoList(controleAtendimentoList);
  }, [controleAtendimentoList]);

  useEffect(() => {
    setControleAtendimentoAutoAtendimentoList(controleAtendimentoList);
  }, [controleAtendimentoList]);

  useEffect(() => {
    if (!isEmpty(controleAtendimentoList))
      setControleAtendimentoAutoAtendimentoList(
        controleAtendimentoList.resultados
      );
  }, [controleAtendimentoList]);

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
    setItensPorPagina(10);
    atualizar(newPage, itensPorPagina);
  };

  useEffect(() => {
    if (!controleAtendimentoList.total) {
      atualizar(0, 10);
    }
  }, [dispatch, !controleAtendimentoList.total]);

  useEffect(() => {
    atualizar(0, 10);
  }, [entrou]);

  const fecharComponenteModal = async () => {
    if (editarModal) {
      await dispatch(finalizarAutoAtendimento(registro));
    } else if (addModal) {
      await dispatch(liberarAutoAtendimento(registro));
    }
    atualizar(0, itensPorPagina);
    limparModal();
  };

  const limparModal = () => {
    setIsEdit(false);
    setEditarModal(false);
    setAddModal(false);
    setRegistro("");
    setEmpresa("");
  };

  const add = (modelo: any) => {
    setAddModal(true);
    setRegistro(modelo);
    setEmpresa(modelo);
  };

  const editar = useCallback((arg: any) => {
    const modelo = arg;
    setRegistro({
      id: modelo.id,
      nome: modelo.nome,
    });
    setIsEdit(true);
  }, []);

  const tirar = (modelo: any) => {
    setEditarModal(true);
    setRegistro(modelo);
    setEmpresa(modelo);
  };

  const atualizar = (page: number, limit: number) => {
    dispatch(
      painelControleAutoAtendimento({
        page,
        limit,
      })
    );
    setEntrou(true);
  };

  useEffect(() => {
    if (mensagem !== null) {
      setControleAtendimentoAutoAtendimentoList(mensagem?.resultados);
    }
    setMensagem(null);
  }, [mensagem !== null]);

  const columns = useMemo(
    () => [
      {
        header: "",
        accessorKey: "razaoSocial",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <p className="text-muted mb-0">
                  <span className="fw-medium">{cell.row.original.nome}</span>
                </p>
              </div>
            </div>
          </>
        ),
      },
      {
        header: "",
        accessorKey: "criacao",
        size: 120,
        minSize: 120,
        maxSize: 120,
        enableColumnFilter: false,
        cell: (cell: any) => (
          <React.Fragment>
            <div className="d-flex justify-content-end">
              <ul className="list-inline mb-0">
                <li className="list-inline-item" style={{ paddingLeft: 100 }}>
                  {formatarDataHora(cell.row.original.criacao)}
                </li>
              </ul>
            </div>
          </React.Fragment>
        ),
      },
      {
        id: "acao",
        header: "",
        size: 120,
        minSize: 120,
        maxSize: 120,
        cell: (cell: any) => {
          return (
            <React.Fragment>
              <div className="d-flex justify-content-end">
                <ul className="list-inline mb-0">
                  {cell.row.original.liberado === "NAO" ? (
                    <li className="list-inline-item">
                      <Link to="#" onClick={() => add(cell.row.original)}>
                        <i className="ri-user-add-line align-bottom me-2 text-warning"></i>
                      </Link>
                    </li>
                  ) : null}
                  <li className="list-inline-item">
                    <Link to="#" onClick={() => editar(cell.row.original)}>
                      <i className="ri-pencil-fill align-bottom me-2 text-primary"></i>
                    </Link>
                  </li>
                  <li className="list-inline-item">
                    <Link
                      to="#"
                      className="remove-item-btn"
                      onClick={() => tirar(cell.row.original)}
                    >
                      <i className="ri-delete-bin-fill align-bottom me-2 text-danger"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <DeleteModal
        show={editarModal || addModal}
        onDeleteClick={() => fecharComponenteModal()}
        onCloseClick={() => limparModal()}
        editarModal={editarModal}
        recordId={empresa?.nome}
        addModal={addModal}
      />
      <Row style={{ paddingTop: 30, textAlign: "center" }}>
        <h3>Auto atendimento</h3>
      </Row>
      <Card id="controleAtendimentoList">
        <CardHeader className="border-0">
          {isControleAtendimentoSuccess &&
          controleAtendimentoAutoAtendimentoList.length > 0 ? (
            <TableContainer
              columns={columns}
              data={controleAtendimentoAutoAtendimentoList || []}
              customPageSize={itensPorPagina}
              divClass="table-responsive"
              tableClass=""
              theadClass="table-light"
              totalPaginas={controleAtendimentoList?.totalPaginas || 1}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              totalRegistros={controleAtendimentoList?.totalPagina || 0}
              itensPorPagina={itensPorPagina}
              aparecerHeader={false}
              aparecerPaginacao={true}
            />
          ) : (
            <Alert color="danger" className="border-0 mb-xl-0">
              <i className="ri-error-warning-line label-icon"></i>
              <strong style={{ paddingLeft: "10px" }}>Sem registros</strong> !!!
            </Alert>
          )}
        </CardHeader>
      </Card>
    </React.Fragment>
  );
};

export default PainelControleListaAutoAtendimento;
